angular.module('impactx.search').controller('MinimizedSearchFiltersCtrl', MinimizedSearchFiltersCtrl);

MinimizedSearchFiltersCtrl.$inject = ['$scope'];

function MinimizedSearchFiltersCtrl($scope)
{
    $scope.getFacet = function(facet) {
        var drillDowns = $scope.fixedFilters.drillDowns;
        if(drillDowns.length > 0) {
            return drillDowns.filter(function(item) {
                return item.patId === facet.id;
            })[0];
        }
    };

    $scope.getFacetValue = function(facet) {
        var value = $scope.getFacet(facet);
        if(value) {
            return value.label;
        }
    };
    
    $scope.toggleSearch = function() {
        $scope.showSearch.value = !$scope.showSearch.value;
    };


    $scope.removeFilter = function(filter, clearValue) {
        if (filter) {
            clearFilter(filter, clearValue);
            $scope.search();
        }
    };
    
    $scope.removeSearchInput = function() {
        $scope.clearSearchInput();
        $scope.search();
    };

    $scope.removeAllFilters = function() {
        var filterdata = $scope.fixedFilters;
        if(filterdata) {
            while(filterdata.drillDowns.length > 0) {
                var item = filterdata.drillDowns[0];
                $scope.toggleDrillDown({item: item});
            }

            $scope.clearSearchInput();
            clearFilter(filterdata.supplier);
            clearFilter(filterdata.manufacturer);
            clearFilter(filterdata.contractNo);
            clearFilter(filterdata.supplierNo);
            clearFilter(filterdata.category);
            clearFilter(filterdata.sort);
            clearFilter(filterdata.priceRange.minValue, 0);
            clearFilter(filterdata.priceRange.maxValue, 0);

            $scope.search();
        }
    };

    $scope.anyFiltersSet = function() {
        var filterdata = $scope.fixedFilters;
        if(filterdata) {
            if (filterdata.drillDowns && filterdata.drillDowns.length > 0) {
                return true;
            }
            return !!$scope.searchInput
                || checkFilter(filterdata.supplier)
                || checkFilter(filterdata.manufacturer)
                || checkFilter(filterdata.contractNo)
                || checkFilter(filterdata.supplierNo)
                || checkFilter(filterdata.category)
                || checkFilter(filterdata.sort)
                || checkFilter(filterdata.priceRange.minValue)
                || checkFilter(filterdata.priceRange.maxValue);
        }
        return false;
    };

    var checkFilter = function(filter) {
        return !!(filter && (filter.value || filter.selected))
    };

    var clearFilter = function(filter, clearValue) {
        if(filter){
            if(filter.selected){
                filter.selected = undefined;
            }
            else {
                filter.value = clearValue;
            }
        }
    };
}